module.exports = {
  search: {
    api: {
      path: "https://www.googleapis.com/customsearch/v1",
      cx: "c2837967a838b0c3a",
    },
  },
};
